import { render, staticRenderFns } from "./UnfixedThead.vue?vue&type=template&id=012db936&"
import script from "./UnfixedThead.vue?vue&type=script&lang=js&"
export * from "./UnfixedThead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports